import script from "./ChatMyExportsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMyExportsModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatMyExportsModal.vue?vue&type=style&index=0&id=1b4e3de7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b4e3de7"]])

export default __exports__